// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__9USWT","dragIcon":"SortableItem_dragIcon__26ds-","disabled":"SortableItem_disabled__7eOS6"};